import React from 'react';
import {observer} from "mobx-react";
import styles from "./CreateForm.module.scss";
import FormConfiguration, {
    BackCreateWidgetHome,
    BoutonSupprimerWidget,
    TitreConfigurerPhidget,
    WidgetTitre
} from "./FormConfiguration";
import WidgetConsignesContentParametres from "../Widgets/WidgetConsignes/views/WidgetConsignesContentParametres";
import WidgetConsignesContentPhotoList from "../Widgets/WidgetConsignes/views/WidgetConsignesContentPhotoList";
import {Button} from "react-bootstrap";
import {useStores} from "../../stores/Context";
import {v4 as uuidv4} from "uuid";
import BtnPrimary from "../../boiteAOutils/BtnPrimary";
import BtnSecondary from "../../boiteAOutils/BtnSecondary";

const CreateConsignes = observer(() => {
    const {createWidgetStore, widgetStore, uiStore} = useStores();

    const handleAddWidgetConsignes = () => {
        widgetStore.addWidgetAvailable({
            idWidget: uuidv4()
            , typeWidget: 'WidgetConsignes'
            , nomWidget: 'Consignes'
        });
        uiStore.backNivOAfterAddPhidget();
    }

    const handleCancelAddConsignes = () => {
        uiStore.openCreationMode();
        createWidgetStore.resetCreateWidget();
    }


    return (
        <>

            <div>
                <TitreConfigurerPhidget/>
                <WidgetTitre titre={"Consignes"}/>
            </div>

            <div className={styles.form_add_widget_consigne}>
                <WidgetConsignesContentParametres createMode={true}/>
            </div>


            {
                createWidgetStore.idWidgetModification === '' ? (
                    <div className={styles.WidgetButtonContent}>
                        <BtnPrimary onClick={handleAddWidgetConsignes}>Ajouter à mes phidgets</BtnPrimary>
                        <BtnSecondary onClick={handleCancelAddConsignes}>Annuler</BtnSecondary>
                    </div>
                ) : (
                    <div className={styles.WidgetButtonContent} style={{justifyContent: "space-between"}}>
                        <BoutonSupprimerWidget idWidget={createWidgetStore.idWidgetModification}
                                               widgetName={'Consignes'}
                                               typeWidget={"WidgetConsignes"}
                        />

                        <FormConfiguration text={'Fermer'}/>
                    </div>
                )
            }

        </>
    );
});

export default CreateConsignes;